<div #subSelectionPanel class="generic-sub-section-wrapper" *ngIf="subSelectionPanelClose">

  <section class="sub-selection-header">
    <div class="icon-backward" (click)="scrollBackward()">
      <i class="icon__dls-navigation-left-x-bold-32">
      </i>
    </div>

    <div class="sub-selection-title">{{subItems.itemName}}</div>
  </section>

  <ng-container *ngIf="nested">
    <ng-container *ngTemplateOutlet="genericSubSelection">
    </ng-container>
  </ng-container>

  <section #genericSubSelection *ngIf="subItems.list">
    <ng-container *ngIf="pncSource; else otherOptions">
      <div class="sub-selection-item" *ngFor="let subItem of subItems.list">
        <div class="sub-item-wrapper item-wrapper" *ngIf="subItem.list.length === 0 && subItem.nodeType === 'item'">

          <ng-container [ngSwitch]="selectionType">
            <div *ngSwitchCase="'tab'" class="{{subItem.itemId}} item-tab"
              [ngClass]="{'item-selected': subItem?.selected === true}" (click)="openSubItem(subItem)">
              <span class="display-item">
                {{subItem.itemName}}
              </span>
            </div>
            <div class="checkbox-item-wrapper" >
            <p-checkbox *ngSwitchDefault class="{{subItem.itemId}} selection-item" checkboxIcon="icon__Checkmark1"
              [ngClass]="{'item-selection-disable': !permitItemSelectionWrite}" value="{{subItem.itemId}}"
              label="{{subItem.itemName}}" [disabled]="!permitItemSelectionWrite"
              (onChange)="toggleVisibility(subItem)" [(ngModel)]="subItem.code" binary="true">
            </p-checkbox>
            </div>
          </ng-container>

        </div>

        <div *ngIf="subItem.nodeType === 'form'">
          <gen-dynamic-form class="subject-form" [formName]="subItem.formId" [formData]="subItem[subItems.itemId]"
            [listenToDataChange]="true" [stayInFormMode]="true"
            (formChange)="updateFormData($event, subItem,subItems, subItem[subItems.itemId])" [formVertical]="true"
            [resetForm]="reset" (validateChange)="updateValidate($event)" [disabled]="!permitItemSelectionWrite">
          </gen-dynamic-form>
        </div>

        <section class="item-wrapper" *ngIf="subItem.list.length > 0">
          <div class="group-item-title sub-item-title">{{subItem.itemName}}</div>
          <div class="sub-selection-item" *ngFor="let groupItem of subItem.list | sortBy: sortByItem; let i = index">

            <div class="checkbox-item-wrapper checkbox-wrapper" *ngIf="groupItem.nodeType === 'item'">
              <ng-container [ngSwitch]="selectionType">
                <div *ngSwitchCase="'tab'" class="{{groupItem.itemId}} item-tab"
                  [ngClass]="{'item-selected': groupItem?.selected === true}" (click)="openSubItem(groupItem)">
                  <span class="display-item">
                    {{groupItem.itemName}}
                  </span>
                </div>

                <p-checkbox *ngSwitchDefault class="{{groupItem.itemId}} selection-item"
                  [ngClass]="{'item-selection-disable': !permitItemSelectionWrite}" value="{{groupItem.itemId}}"
                  label="{{groupItem.itemName}}" [disabled]="!permitItemSelectionWrite"
                  (onChange)="toggleVisibility(groupItem)" [(ngModel)]="groupItem.code" binary="true">
                </p-checkbox>
              </ng-container>
            </div>

            <div *ngIf="groupItem.nodeType === 'form'">
              <gen-dynamic-form class="subject-form" [formName]="groupItem.formId"
                [formData]="groupItem[subItem.itemId]" [listenToDataChange]="true" [stayInFormMode]="true"
                (formChange)="updateFormData($event, groupItem, subItem, groupItem[subItem.itemId])"
                [formVertical]="true" [resetForm]="reset" (validateChange)="updateValidate($event)"
                [disabled]="!permitItemSelectionWrite"></gen-dynamic-form>
            </div>

          </div>
        </section>


      </div>
    </ng-container>

    <ng-template #otherOptions>
      <div class="sub-selection-item" *ngFor="let subItem of subItems.list | sortBy: sortByIndex : sortByItem; let i = index">

      <div class="sub-item-wrapper item-wrapper" *ngIf="subItem.list.length === 0 && subItem.nodeType === 'item'">

        <ng-container [ngSwitch]="selectionType">
          <div *ngSwitchCase="'tab'" class="{{subItem.itemId}} item-tab"
               [ngClass]="{'item-selected': subItem?.selected === true}"
               (click)="openSubItem(subItem)">
            <span class="display-item">
              {{subItem.itemName}}
            </span>
          </div>
          <div class="checkbox-item-wrapper" >
          <p-checkbox *ngSwitchDefault class="{{subItem.itemId}} selection-item"
                      checkboxIcon="icon__Checkmark1"
                      [ngClass]="{'item-selection-disable': !permitItemSelectionWrite}"
                      value="{{subItem.itemId}}"
                      label="{{subItem.itemName}}"
                      [disabled]="!permitItemSelectionWrite"
                      (onChange)="toggleVisibility(subItem)"
                      [(ngModel)]="subItem.code"
                      binary="true">
          </p-checkbox>
          </div>
        </ng-container>

        </div>

        <div *ngIf="subItem.nodeType === 'form'">
          <gen-dynamic-form class="subject-form" [formName]="subItem.formId" [formData]="subItem[subItems.itemId]"
            [listenToDataChange]="true" [stayInFormMode]="true"
            (formChange)="updateFormData($event, subItem,subItems, subItem[subItems.itemId])" [formVertical]="true"
            [resetForm]="reset" (validateChange)="updateValidate($event)" [disabled]="!permitItemSelectionWrite">
          </gen-dynamic-form>
        </div>

        <section class="item-wrapper" *ngIf="subItem.list.length > 0">
          <div class="group-item-title sub-item-title">{{subItem.itemName}}</div>
          <div class="sub-selection-item" *ngFor="let groupItem of subItem.list | sortBy: sortByItem; let i = index">

          <div class="checkbox-item-wrapper checkbox-wrapper" *ngIf="groupItem.nodeType === 'item'">
            <ng-container [ngSwitch]="selectionType">
              <div *ngSwitchCase="'tab'" class="{{groupItem.itemId}} item-tab"
                   [ngClass]="{'item-selected': groupItem?.selected === true}"
                   (click)="openSubItem(groupItem)">
              <span class="display-item">
                {{groupItem.itemName}}
              </span>
              </div>

                <p-checkbox *ngSwitchDefault class="{{groupItem.itemId}} selection-item"
                  [ngClass]="{'item-selection-disable': !permitItemSelectionWrite}" value="{{groupItem.itemId}}"
                  label="{{groupItem.itemName}}" [disabled]="!permitItemSelectionWrite"
                  (onChange)="toggleVisibility(groupItem)" [(ngModel)]="groupItem.code" binary="true">
                </p-checkbox>
              </ng-container>
            </div>

            <div *ngIf="groupItem.nodeType === 'form'">
              <gen-dynamic-form class="subject-form" [formName]="groupItem.formId"
                [formData]="groupItem[subItem.itemId]" [listenToDataChange]="true" [stayInFormMode]="true"
                (formChange)="updateFormData($event, groupItem, subItem, groupItem[subItem.itemId])"
                [formVertical]="true" [resetForm]="reset" (validateChange)="updateValidate($event)"
                [disabled]="!permitItemSelectionWrite"></gen-dynamic-form>
            </div>

          </div>
        </section>
      </div>
    </ng-template>
  </section>
</div>